import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import { Box, IconButton, Input, Stack, Tooltip, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import React, { ChangeEvent } from 'react'
import { StyledImageContainer, StyledImg } from './styles'
import InfoIcon from '@mui/icons-material/Info'

import noPhoto from 'assets/noPhoto.png'

type InputPictureProps = {
  image?: File | null
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void
  handleReset?: () => void
  uploadMode?: boolean
  disabled?: boolean
  metadados?: {
    nomeArquivo?: string | null
    tipoArquivo?: string | null
    tamanho?: string | null
  }
}

const UploadPicture: React.FC<InputPictureProps> = ({
  image,
  handleReset,
  handleChange,
  uploadMode = true,
  disabled,
  metadados,
}) => {
  const handleImage = (file?: File): string | undefined => {
    if (file) {
      return URL.createObjectURL(file)
    }
  }

  return (
    <Box flexDirection='column'>
      <StyledImageContainer justifyContent='center' alignItems='center' spacing={2}>
        {image ? (
          <Tooltip
            title={
              <Box display={'flex'} gap={2}>
                <small>{metadados?.nomeArquivo}</small>
                <small>{metadados?.tamanho}</small>
              </Box>
            }
          >
            <StyledImg src={handleImage(image)} alt='Selected' />
          </Tooltip>
        ) : (
          <StyledImg src={noPhoto} />
        )}
        <Box display={'flex'} gap={1}>
          <Typography variant={'body1'}>Foto do Adolescente</Typography>
          <Tooltip
            title={
              'Os tipos permitidos de imagens são: PNG, BMP, TIFF, JPG e JPEG e tamanho máximo é de 2MB'
            }
          >
            <InfoIcon fontSize={'small'} />
          </Tooltip>
        </Box>
        {uploadMode && (
          <>
            <Input
              type='file'
              id='upload-foto'
              onChange={handleChange}
              style={{ display: 'none' }}
              inputProps={{
                accept: '.png, .bmp, .tiff, .jpg, .jpeg',
              }}
              disabled={disabled}
            />
            <Stack direction='row' spacing={1}>
              <label htmlFor={`upload-foto`}>
                <Button variant='contained' color='secondary' component='span' disabled={disabled}>
                  Buscar Imagem
                </Button>
              </label>
              {image && (
                <IconButton onClick={handleReset}>
                  <DeleteOutlineRoundedIcon color='error' />
                </IconButton>
              )}
            </Stack>
          </>
        )}
      </StyledImageContainer>
    </Box>
  )
}

export default UploadPicture
